import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19ae9546"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["onClick"]

import { ref, computed, onMounted, withDefaults } from 'vue'
import type { CSSProperties } from 'vue'
import { CloseFn } from './index'
export interface Options {
  message?: string
  id?: string
  offset?: number
  zIndex?: number
  duration?: number
  type?: 'success' | 'error' | 'warning'| 'info'
  onClose?: CloseFn
  customClass?: string
  showClose?: boolean
  center?: boolean
}
interface Emits {
  (e:'destroy'):true
}

export default /*#__PURE__*/_defineComponent({
  props: {
    message: { default: '' },
    id: { default: '' },
    offset: { default: 20 },
    zIndex: { default: 1000 },
    duration: { default: 3000 },
    type: { default: 'info' },
    onClose: { default: () => true },
    customClass: { default: '' },
    showClose: { default: true },
    center: { default: false }
  },
  emits: ["destroy"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e:'destroy'):true
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message: string, id: string, offset: number, zIndex: number, duration: number, type: 'success' | 'error' | 'warning'| 'info', onClose: CloseFn, customClass: string, showClose: boolean, center: boolean }



const visible = ref(false)
const customStyle = computed<CSSProperties>(() => ({
  top: `${props.offset}px`,
  zIndex: props.zIndex
}))
let timer: any
const startTimer = () => {
  if (props.duration > 0) {
    timer = setTimeout(() => {
      if (visible.value) close()
    }, props.duration)
  }
}
function clearTimer () {
  clearTimeout(timer)
}
const afterLeave = () => {
  emits('destroy')
}

const beforeLeave = () => {
  props.onClose()
}
onMounted(() => {
  startTimer()
  visible.value = true
})
const close = () => {
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "permaMessage-fade",
    onAfterLeave: afterLeave,
    onBeforeLeave: beforeLeave
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        id: __props.id,
        class: _normalizeClass([
        'perma-message',
        `perma-message--${__props.type ? __props.type : 'info'}`,
        __props.customClass
      ]),
        style: _normalizeStyle(_unref(customStyle)),
        onMouseenter: clearTimer,
        onMouseleave: startTimer
      }, [
        (__props.type)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(['perma-message__icon', `el-icon-${__props.type ? __props.type : 'info`'}`])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass(["perma-message__content", [__props.center ? 'perma-message-center' : '']])
        }, _toDisplayString(__props.message), 3),
        (__props.showClose)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "el-icon-close perma-message__closeBtn",
              onClick: _withModifiers(close, ["stop"])
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 46, _hoisted_1), [
        [_vShow, visible.value]
      ])
    ]),
    _: 1
  }))
}
}

})